import { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { Mic, MicOff } from "lucide-react";

const CountdownCircleTimer = ({ duration = 10, active = false, onClick, disabled = false }) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const intervalRef = useRef(null);

  const size = 80;
  const radius = 35;
  const strokeWidth = 4;
  const circumference = 2 * Math.PI * radius;

  const calculateOffset = (current) =>
    circumference - (current / duration) * circumference;

  // Reset timer when duration or active changes
  useEffect(() => {
    if (active) {
      setTimeLeft(duration);
    }
  }, [duration, active]);

  // Start / stop interval
  useEffect(() => {
    if (!active) {
      clearInterval(intervalRef.current);
      return;
    }

    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [active]);

  return (
    <div className="d-flex flex-column align-items-center gap-2">
      <div className="d-flex gap-2 justify-content-center align-items-center" style={{ width: "100%", height: "100%" }}>
        <Button
          variant={active ? "danger" : "primary"}
          className="rounded-circle d-flex justify-content-center align-items-center"
          style={{ 
            width: 56, 
            height: 56, 
            zIndex: 1,
            boxShadow: active ? "0 0 15px rgba(220, 53, 69, 0.5)" : "0 0 10px rgba(13, 110, 253, 0.3)"
          }}
          onClick={onClick}
          disabled={disabled}
        >
          {active ? <MicOff size={24} /> : <Mic size={24} />}
        </Button>
        {/* Timer Display */}
        {active && (
          <span className="text-primary fw-semibold">
            {timeLeft}s
          </span>
        )}
      </div>
    </div>
  );
};

export default CountdownCircleTimer;
